import { Typography } from "@mui/material";
import React from "react";

const NoRecordsFound = () => {
  return (
    <div>
      <Typography
        style={{
          color: "#FF3131",
          fontSize: "13px",
          textAlign: "center",
          fontWeight: "bold",
        }}
        my={2}
      >
        No Records Found !!
      </Typography>
    </div>
  );
};

export default NoRecordsFound;
